import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Brain, Sparkles } from "lucide-react";

export default function ResumeModal({ open, onOpenChange, text, loading, task }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="glass-modal text-white max-w-2xl rounded-3xl p-0 overflow-hidden"
        data-testid="ai-resume-modal"
      >
        <div className="p-8 md:p-10">
          <DialogHeader>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-11 h-11 rounded-2xl bg-[hsl(var(--green))]/15 border border-[hsl(var(--green))]/40 flex items-center justify-center">
                <Brain className="w-5 h-5 text-[hsl(var(--green))]" />
              </div>
              <div>
                <DialogTitle className="font-display text-3xl font-black tracking-tighter">
                  Resume here.
                </DialogTitle>
                <DialogDescription className="text-white/50 text-sm">
                  Claude reviewed your train of thought
                  {task ? ` for “${task}”` : ""}.
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>

          <div className="mt-6">
            {loading ? (
              <div className="space-y-3" data-testid="resume-loading">
                <div className="h-4 rounded bg-white/5 animate-pulse w-1/2" />
                <div className="h-4 rounded bg-white/5 animate-pulse w-3/4" />
                <div className="h-4 rounded bg-white/5 animate-pulse w-5/6" />
                <div className="h-4 rounded bg-white/5 animate-pulse w-2/3" />
                <div className="flex items-center gap-2 pt-3 text-xs font-mono text-white/40">
                  <Sparkles className="w-3.5 h-3.5 text-[hsl(var(--green))]" />
                  Stitching your thoughts back together…
                </div>
              </div>
            ) : (
              <div
                className="whitespace-pre-wrap text-[15px] leading-[1.65] text-white/90 font-mono"
                data-testid="resume-summary-text"
              >
                {text || "No summary available yet."}
              </div>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
